export enum AttachmentType {
    Invoice = 'invoice',
    Agreement = 'agreement',
    PaymentProcessingAgreement = 'payment-processing-agreement',
    Shipping = 'shipping',
    TaxReturn = 'tax-return',
    BuyerGuarantee = 'buyer-guarantee',
    BankStatement = 'bank-statement',
    AuditedFinancialStatement = 'audited-financial-statement',
    IncorporationDocument = 'incorporation-document',
    BankOwnership = 'bank-ownership',
    SignatoryRights = 'signatory-rights',
    Other = 'other',
    OrdersHistory = 'orders-history',
    BusinessOwner = 'business-owner',
    ExternalFile = 'external-file',
    TransferConfirmation = 'transfer-confirmation',
    GlobalAccountConfirmation = 'global-account-confirmation',
    Businesslicense = 'business-license',
    TransactionConfirmation = 'transaction-confirmation',
    ProofOfPayment = 'proof-of-payment',
}
